const initSelectedTopFacets = () => {
  const selectFacetElems = document.querySelectorAll('.search-top-facets select');

  if (null === selectFacetElems) {
    return;
  }

  // Redirect when options is selected in top-facets
  [].forEach.call(selectFacetElems, function (selectElem) {
    selectElem.addEventListener('change', () => {
      const selected = selectElem.options[selectElem.options.selectedIndex];
      const url = selected.getAttribute('data-url');
      if (typeof url !== 'undefined') {
        window.location.href = url;
      }
    });
  });
};

export default initSelectedTopFacets;

